import {PandoraCollarKeys, PasiphaeGeneratedScheduleFiles, ProductionTestFiles} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public PandoraCollarKeys: PandoraCollarKeys,
    public PasiphaeGeneratedScheduleFiles: PasiphaeGeneratedScheduleFiles,
    public ProductionTestFiles: ProductionTestFiles,
  ) {}
}